import { deepClone } from "@mui/x-data-grid/utils/utils"

const initialState: any = {
    pageData: {
        currentTab: "0"
    },
    data: {},
    incentiveSummaryData : {
        summaryList : []
    },
    thresholdErrorMsg : {
        errorMsg : "Please fill and save all the required fields Correctly"
    }
}

export const manageIncentiveReducer = (state: any = deepClone(initialState), action: { payload: any, type: string, stateName: string }) => {
    switch (action.type) {
        case "reset_data":
            return initialState
        case "updateThresholdErrorMsg" :
            return  {
                ...state,
                thresholdErrorMsg: {
                    ...state.thresholdErrorMsg,
                    errorMsg: action.payload
                }
            }
        case "updateCurrentTab":
            return {
                ...state,
                pageData: {
                    ...state.pageData,
                    currentTab: action.payload
                }
            }
        case "updateValue":
            const newData = { ...state.data };
            newData[action.stateName].value = action.payload
            return {
                ...state,
                data: newData
            }
        case "updateIsOpen":
            const dataToOpen = { ...state.data };
            dataToOpen[action.stateName].isOpen = action.payload
            return {
                ...state,
                data: dataToOpen
            }
        case "updateIsValid":
            const dataToValidate = { ...state.data };
            dataToValidate[action.stateName].isValid = action.payload
            return {
                ...state,
                data: dataToValidate
            }
        case 'resetValue':
            const dataToRemove = { ...state.data };
            if (action.stateName === "kpiSelection" || action.stateName === "userSelection" || action.stateName === "validityDataAndTime") {
                dataToRemove[action.stateName].value = []
            }
            dataToRemove[action.stateName].value = ""
            return {
                ...state,
                data: dataToRemove
            };
        case 'updateData':
            return {
                ...state,
                data: action.payload
            };
            case "updateIncentiveSummaryData":
                return {
                    ...state,
                    incentiveSummaryData: {
                        ...state.incentiveSummaryData, // Ensure existing incentiveSummaryData structure is preserved
                        summaryList: action.payload  // Update summaryList within incentiveSummaryData
                    }
                };
        default:
            return state;
    }
}